import { inject, Injectable } from '@angular/core';

import { type RuntimeContext } from '@blaze-shared/elements-domain';
import { IntelliSenseService } from '@blaze-shared/intellisense-feature';
import { type DatasetRow } from '@blaze-shared/schema-domain';
import { type FilterWorkflowNode } from '@blaze-shared/workflow-domain';

/**
 * Keeps the input rows whose values satisfy the node's condition, which is evaluated once per row.
 *
 * Input that is not a list, or a node with no condition, passes through untouched.
 */
@Injectable({ providedIn: 'root' })
export class FilterActionService {
  private readonly iss = inject(IntelliSenseService);

  filter(node: FilterWorkflowNode, nodeInput: DatasetRow[], ctx: RuntimeContext): DatasetRow[] {
    const condition = node.condition || '';
    if (!condition || !Array.isArray(nodeInput)) {
      return nodeInput;
    }
    return nodeInput.filter((row) =>
      this.iss.eval(condition, this.iss.updateRuntimeContext(ctx, row)),
    );
  }
}
